const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/open-positions/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { compactPicklistFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
const openPositionsSearchSchema = z.object({
  locationId: compactPicklistFilterSchema,
  roleId: compactPicklistFilterSchema,
  skillId: compactPicklistFilterSchema,
  filledStatus: z.enum(['OPEN', 'HIRED', 'ALL']).optional()
});
export const Route = createFileRoute('/(app)/org/$org/settings/open-positions/')({
  validateSearch: zodValidator(openPositionsSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.openPositions)
  }),
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.openPositions)
    }
  }
});